import { atom } from 'jotai'
import type { TOrderDetail } from '../../types/TOrderdetail'

export const orderDetailState = atom<TOrderDetail>({
    time: {
        '1_start_function': 0,
        '2_get_uuid': 0,
        '3_get_product': 0,
        '4_osvpc': 0,
        '5_per_pare_return_data': 0
    },
    hydra: {
        orderValidate: {
            data: 'no order validation'
        }
    },
    ushop: {
        detail_page: {
            display_address: '',
            fullname_jp: '',
            email: '',
            phone: '',
            shipment_options: '',
            period: '',
            shipToAddress: {
                address1: '',
                address2: '',
                city: '',
                country: '',
                state: '',
                zip: ''
            },
            house_number: '',
            town: '',
            district: '',
            prefecture: '',
            zip: '',
            send_confirmation: false,
            login_id: '',
            login_name: '',
            login_name_native: '',
            items: '',
            e_credit_use_amount: 0
        },
        genBeta: {
            formatShippingInfo: {
                email: '',
                phone: ''
            },
            formatSummary: null
        },
        productsDisplay: []
    }
})
